module.exports = __webpack_public_path__ + "static/media/burger-menu.bae48425.svg";